import DimensionListActivity from './DimensionListActivity';

export default DimensionListActivity;
